import type ContractDraftContext from '../drafts/ContractDraftContext';
import { NodeBaseDto, BasicNodeDto, LayersNodeDto, LayersWithSectionsNodeDto, SectionsNodeDto } from '../types';
import {
    BasicNodeModel,
    LayersNodeModel,
    LayersWithSectionsNodeModel,
    SectionsNodeModel,
    NodeBaseModel
} from '../models';
import { SourceModelBase } from '../../custom_shared/models';

export default class NodeFactory {
    static createOrUpdateNodes(
        data: NodeBaseDto[],
        existingNodes: NodeBaseModel[],
        sources: SourceModelBase[],
        context: ContractDraftContext
    ) {
        return data.map(nodeDto => {
            const existingNode = existingNodes.find(t => t.id === nodeDto.id);

            if (existingNode) {
                existingNode.inputAvailability = nodeDto.inputAvailability ?? {};
                existingNode.update(nodeDto, sources);

                existingNode.setChildNodes(
                    nodeDto.childNodes.length
                        ? [
                              ...NodeFactory.createOrUpdateNodes(
                                  nodeDto.childNodes,
                                  existingNode.childNodes,
                                  sources,
                                  context
                              )
                          ]
                        : []
                );

                return existingNode;
            }

            const newNode = NodeFactory.createNode(nodeDto, sources, context);

            if (nodeDto.childNodes.length) {
                newNode.setChildNodes([...NodeFactory.createOrUpdateNodes(nodeDto.childNodes, [], sources, context)]);
            }

            return newNode;
        });
    }

    static createNode(data: NodeBaseDto, sources: SourceModelBase[], context: ContractDraftContext) {
        switch (data.type) {
            case 'Basic':
                return new BasicNodeModel(data as BasicNodeDto, sources, context);
            case 'Layers':
                return new LayersNodeModel(data as LayersNodeDto, sources, context);
            case 'LayersWithSections':
                return new LayersWithSectionsNodeModel(data as LayersWithSectionsNodeDto, sources, context);
            case 'Sections':
                return new SectionsNodeModel(data as SectionsNodeDto, sources, context);
            default:
                throw new Error('Unsupported node type');
        }
    }
}
